"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconUpload = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M9,16.5 L9,10.5 L5,10.5 L12,3.5 L19,10.5 L15,10.5 L15,16.5 L9,16.5 M5,20.5 L5,18.5 L19,18.5 L19,20.5 L5,20.5 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconUpload')(IconUpload);